import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import { DraftComponentMixin } from '../common/mixins/DraftComponentMixin.js'
import style from './parts.css'

/**
 * The header region of a composed [Drawer](/components/drawer/). A fixed zone
 * at the top of the drawer; bring your own heading element or use it directly
 * for a title.
 *
 * Auto-assigns itself to the drawer's `header` slot, so place it as a direct
 * child of `nord-drawer` (no `slot` attribute needed).
 *
 * @status draft
 * @category structure
 * @lightDom true
 *
 * @slot - The drawer header content.
 */
@customElement('nord-drawer-header')
export default class DrawerHeader extends DraftComponentMixin(LitElement) {
  connectedCallback() {
    super.connectedCallback()
    if (!this.hasAttribute('slot')) {
      this.setAttribute('slot', 'header')
    }
    injectLegacyLightDomStyles(this, style, 'nord-drawer-parts')
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-drawer-header': DrawerHeader
  }
}
